<template>
  <v-app id="modal-layout">
    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fill-height fluid>
        <!-- <slot /> -->
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
    name: "ModalLayout"
}
</script>